"use client";

import { ChevronLeft } from "lucide-react";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import { useWebSiteContext } from "@core/helpers/client/contexts/WebSiteContext";
import { build_login_url } from "@core/helpers/auth-redirect";
import PriceComponent from "@/components/ui/Price";
import Button from "@/components/ui/button";
import CartItem from "./_CartItem";

export default function CartPreviewModal({ cart, badge }) {
    const { is_auth } = useAuthContext();
    const { web_route_names } = useWebSiteContext();

    // مهمان هرگز لینک مستقیم چک‌اوت نمی‌گیرد؛ به ورود می‌رود و بعد از آن برمی‌گردد
    const checkout_path = web_route_names?.["checkout-page"] || "/checkout/";
    const checkout_href = is_auth ? checkout_path : build_login_url(web_route_names?.["auth"], checkout_path);

    const totalPrice = cart?.products?.reduce((sum, item) => {
        const price = item?.product?.mix_variant?.[0]?.price?.main_price || 0;
        return sum + (price * item?.count);
    }, 0);

    return (

        <div className="absolute top-full left-0 pt-3 z-30">
            <div className="flex flex-col bg-jmt-white rounded-md shadow-medium overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-between py-3 border-b border-jmt-neutral-200 px-4">
                    <div className="flex items-center gap-2">
                        <span className="font-bold text-sm text-jmt-main text-right">سبدخرید شما</span>
                        <span className="text-xs text-jmt-neutral-500">{badge} محصول</span>
                    </div>
                    <Button
                        href="/cart"
                        end_icon={<ChevronLeft size={16} />}
                        color_type="tertiary"
                        variant="tertiary"
                        text=" مشاهده سبد خرید  "
                    />
                </div>

                {/* CompactCartItem */}
                <div className="max-h-[400px] w-[400px] overflow-y-auto custom-scrollbar px-4">
                    {cart?.products?.map((item, index) => (
                        <div key={index} className="not-last:border-b border-jmt-neutral-200">
                            <CartItem index={index} item={item} variant="modal" className="py-2" />
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="bg-jmt-white border-t border-jmt-neutral-200 py-3 ">
                    <div className="flex items-center justify-between px-4">
                        <div className="flex flex-col">
                            <span className="text-xs text-jmt-neutral-500"> جمع کل : </span>
                            <PriceComponent
                                price={totalPrice}
                                className="font-bold text-jmt-main"
                            />
                        </div>
                        <Button
                            href={checkout_href}
                            text="ثبت سفارش "
                            className="flex w-1/2"
                            color_type="primary"
                        />

                    </div>
                </div>

            </div>
        </div>

    );
}
